module.exports = __webpack_public_path__ + "img/no-product.bff3dc74.png";